import Flickity from 'flickity';

jQuery(document).ready(function($) {
    const $carousel = $('.js-hero-carousel');
    if ($carousel.length === 0) return;

    const $slides = $('.hero__slide');

    // Helper to get random value in range
    function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
    }

    // Set random Ken Burns values on a slide
    function setRandomKenBurns($slide) {
        const $img = $slide.find('.hero__background img');

        const startScale = randomInRange(1.1, 1.2);
        const endRotate = randomInRange(-2.3, 2.3);
        const duration = randomInRange(5.5, 6.5);

        $img.css({
            '--kb-start-scale': startScale,
            '--kb-end-rotate': endRotate + 'deg',
            '--kb-duration': duration + 's'
        });
    }

    // Set initial values on first slide
    setRandomKenBurns($slides.first());

    const flkty = new Flickity($carousel[0], {
        cellSelector: '.hero__slide',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: 5000,
        pauseAutoPlayOnHover: false,
        draggable: true,
        accessibility: true
    });

    // Custom navigation
    const $prev = $('.js-hero-prev');
    const $next = $('.js-hero-next');
    const $current = $('.hero__counter-current');

    $prev.on('click', function() {
        flkty.previous(true);
    });

    $next.on('click', function() {
        flkty.next(true);
    });

    // Update counter and set new random Ken Burns values on slide change
    flkty.on('change', function(index) {
        $current.text(index + 1);
        setRandomKenBurns($slides.eq(index));
    });
});
